module.exports = __webpack_public_path__ + "static/img/logoTwo.60f80b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageThree/logoTwo.png
// module id = V3gA
// module chunks = 0